import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-campanha-roi-widgets',
    templateUrl: './campanha-roi-widgets.component.html',
    styleUrls: ['./campanha-roi-widgets.component.less']
})
export class CampanhaROIWidgetsComponent {
    @Input() isLoading: boolean;
    @Input() valorTotalRecursos: number;
    @Input() valorTotalResultado: number;
    @Input() roi: number;
}
